(() => {
  const moveStockInfo = () => {
    // Check if the script has already run
    if (document.body.classList.contains('stock-info-modified')) {
      return true;
    }

    const headline = document.querySelector('.product__title');
    const stockContainerDesktop = document.querySelector('.product__info-container .flex-wrap.small-hide.medium-hide');
    const stockContainerMobile = document.querySelector('.product__info-container .in-stock-display');

    let stockElement = stockContainerDesktop || stockContainerMobile;

    if (headline && stockElement && stockElement.textContent.includes('Auf Lager')) {
      // Create the new element
      const newStockElement = document.createElement('div');
      newStockElement.className = 'custom-stock-status';
      newStockElement.innerHTML = '<span class="in-stock">Auf Lager</span> - Versand binnen 24 Stunden';

      // Insert it after the product title
      headline.insertAdjacentElement('afterend', newStockElement);

      // Hide the original elements
      if (stockContainerDesktop) {
        stockContainerDesktop.style.display = 'none';
      }
      if (stockContainerMobile) {
        stockContainerMobile.style.display = 'none';
      }

      // Mark as done
      document.body.classList.add('stock-info-modified');
      return true;
    }
    return false;
  };

  // Stop observing once the element is found and moved
  const observer = new MutationObserver((mutations, obs) => {
    if (moveStockInfo()) {
      obs.disconnect();
    }
  });

  // Try to run the function on load, if it fails, start observing
  if (!moveStockInfo()) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
